/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { ConfigurationItemDTO } from "./ConfigurationItemDTO";
import {
  ConfigurationItemDTOFromJSON,
  ConfigurationItemDTOFromJSONTyped,
  ConfigurationItemDTOToJSON
} from "./ConfigurationItemDTO";
import type { GenericIdDTO } from "./GenericIdDTO";
import { GenericIdDTOFromJSON, GenericIdDTOFromJSONTyped, GenericIdDTOToJSON } from "./GenericIdDTO";
import type { MerchantDTO } from "./MerchantDTO";
import { MerchantDTOFromJSON, MerchantDTOFromJSONTyped, MerchantDTOToJSON } from "./MerchantDTO";
import type { PlatformRefDTO } from "./PlatformRefDTO";
import { PlatformRefDTOFromJSON, PlatformRefDTOFromJSONTyped, PlatformRefDTOToJSON } from "./PlatformRefDTO";
import type { ProductDealSortDTO } from "./ProductDealSortDTO";
import {
  ProductDealSortDTOFromJSON,
  ProductDealSortDTOFromJSONTyped,
  ProductDealSortDTOToJSON
} from "./ProductDealSortDTO";

/**
 *
 * @export
 * @interface CreateExternalDealFilterDTO
 */
export interface CreateExternalDealFilterDTO {
  /**
   *
   * @type {PlatformRefDTO}
   * @memberof CreateExternalDealFilterDTO
   */
  platform: PlatformRefDTO;
  /**
   *
   * @type {string}
   * @memberof CreateExternalDealFilterDTO
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof CreateExternalDealFilterDTO
   */
  productFeedUrl?: string;
  /**
   *
   * @type {string}
   * @memberof CreateExternalDealFilterDTO
   */
  lastRunStartDate?: string;
  /**
   *
   * @type {string}
   * @memberof CreateExternalDealFilterDTO
   */
  lastRunEndDate?: string;
  /**
   *
   * @type {string}
   * @memberof CreateExternalDealFilterDTO
   */
  nextRunAtDate?: string;
  /**
   *
   * @type {number}
   * @memberof CreateExternalDealFilterDTO
   */
  runIntervalSeconds: number;
  /**
   *
   * @type {string}
   * @memberof CreateExternalDealFilterDTO
   */
  searchQuery?: string;
  /**
   *
   * @type {boolean}
   * @memberof CreateExternalDealFilterDTO
   */
  live: boolean;
  /**
   *
   * @type {Array<MerchantDTO>}
   * @memberof CreateExternalDealFilterDTO
   */
  merchants: Array<MerchantDTO>;
  /**
   *
   * @type {Array<GenericIdDTO>}
   * @memberof CreateExternalDealFilterDTO
   */
  categories?: Array<GenericIdDTO>;
  /**
   *
   * @type {number}
   * @memberof CreateExternalDealFilterDTO
   */
  productDealLimit: number;
  /**
   *
   * @type {ProductDealSortDTO}
   * @memberof CreateExternalDealFilterDTO
   */
  productDealSort: ProductDealSortDTO;
  /**
   *
   * @type {Array<ConfigurationItemDTO>}
   * @memberof CreateExternalDealFilterDTO
   */
  configurations?: Array<ConfigurationItemDTO>;
}

/**
 * Check if a given object implements the CreateExternalDealFilterDTO interface.
 */
export function instanceOfCreateExternalDealFilterDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "platform" in value;
  isInstance = isInstance && "title" in value;
  isInstance = isInstance && "runIntervalSeconds" in value;
  isInstance = isInstance && "live" in value;
  isInstance = isInstance && "merchants" in value;
  isInstance = isInstance && "productDealLimit" in value;
  isInstance = isInstance && "productDealSort" in value;

  return isInstance;
}

export function CreateExternalDealFilterDTOFromJSON(json: any): CreateExternalDealFilterDTO {
  return CreateExternalDealFilterDTOFromJSONTyped(json, false);
}

export function CreateExternalDealFilterDTOFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateExternalDealFilterDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    platform: PlatformRefDTOFromJSON(json["platform"]),
    title: json["title"],
    productFeedUrl: !exists(json, "productFeedUrl") ? undefined : json["productFeedUrl"],
    lastRunStartDate: !exists(json, "lastRunStartDate") ? undefined : json["lastRunStartDate"],
    lastRunEndDate: !exists(json, "lastRunEndDate") ? undefined : json["lastRunEndDate"],
    nextRunAtDate: !exists(json, "nextRunAtDate") ? undefined : json["nextRunAtDate"],
    runIntervalSeconds: json["runIntervalSeconds"],
    searchQuery: !exists(json, "searchQuery") ? undefined : json["searchQuery"],
    live: json["live"],
    merchants: (json["merchants"] as Array<any>).map(MerchantDTOFromJSON),
    categories: !exists(json, "categories") ? undefined : (json["categories"] as Array<any>).map(GenericIdDTOFromJSON),
    productDealLimit: json["productDealLimit"],
    productDealSort: ProductDealSortDTOFromJSON(json["productDealSort"]),
    configurations: !exists(json, "configurations")
      ? undefined
      : (json["configurations"] as Array<any>).map(ConfigurationItemDTOFromJSON)
  };
}

export function CreateExternalDealFilterDTOToJSON(value?: CreateExternalDealFilterDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    platform: PlatformRefDTOToJSON(value.platform),
    title: value.title,
    productFeedUrl: value.productFeedUrl,
    lastRunStartDate: value.lastRunStartDate,
    lastRunEndDate: value.lastRunEndDate,
    nextRunAtDate: value.nextRunAtDate,
    runIntervalSeconds: value.runIntervalSeconds,
    searchQuery: value.searchQuery,
    live: value.live,
    merchants: (value.merchants as Array<any>).map(MerchantDTOToJSON),
    categories: value.categories === undefined ? undefined : (value.categories as Array<any>).map(GenericIdDTOToJSON),
    productDealLimit: value.productDealLimit,
    productDealSort: ProductDealSortDTOToJSON(value.productDealSort),
    configurations:
      value.configurations === undefined
        ? undefined
        : (value.configurations as Array<any>).map(ConfigurationItemDTOToJSON)
  };
}
